import { render, staticRenderFns } from "./TipologiaPremioVitaProtezioneBarChart.vue?vue&type=template&id=7f07ba83&"
import script from "./TipologiaPremioVitaProtezioneBarChart.vue?vue&type=script&lang=js&"
export * from "./TipologiaPremioVitaProtezioneBarChart.vue?vue&type=script&lang=js&"
import style0 from "./TipologiaPremioVitaProtezioneBarChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports